<template>
    <div class="table-wrapper">
        <!-- <high-search> -->
            <Form style="padding-top: 24px;" ref="formInline" :model="formInline" inline class="form-list"
                  :label-width="100" label-position="right">

                  <div class="search-right-wrapper">
                    <Button :loading="eLoading" type="primary" style="float:left;" icon="ios-exit-outline" @click="handleExport">导出</Button>
                    <FormItem label="企业名称：" prop="corpName" style="width:286px;text-align:left;">
                        <Input v-model="formInline.corpName" placeholder="请输入企业名称"></Input>
                    </FormItem>
                    <FormItem label="企业类型：" prop="corpType" style="width:286px;text-align:left;">
                        <Select v-model="formInline.corpType" placeholder="请选择企业类型" clearable>
                            <Option v-for="(item,index) in copeRegisterTypeArr" :value="item.code" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="企业注册地：" style="width:286px;text-align:left;">
                         <Cascader :data="countiesAll" v-model="corpAreaCode" change-on-select @on-change="changeSelect"></Cascader>
                        <!-- <place-select v-model="formInline.areaCode"></place-select> -->
                        <!--<Select v-model="areaCode" clearable>-->
                            <!--<Option v-for="item in area" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
                        <!--</Select>-->
                    </FormItem>
                <Button style="float: right;margin-left:10px" type="primary" @click="reset">重置</Button>
                <Button style="float: right;" type="primary" @click="handleQuery">搜索</Button>
            </div>
            </Form>
        <!-- </high-search> -->
        <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="action">
                <Button class="table-btn" type="text" size="small" @click="handleDeal('unitDetail',row.corpId)">详情</Button>
                <Button class="table-btn" type="text" size="small" @click="handleEdit(row)">编辑</Button>
            </template>
        </Table>
        <div class="t-page">
            <Page :total="totalCount" :page-size="pageSize" :current="page"
                  @on-change="changePage" @on-page-size-change="pageSizeChange"
                  show-elevator show-sizer show-total transfer>
            </Page>
        </div>
        <Modal
                v-model="modalq"
                title="企业信息编辑"
                width="600"
        >
            <Form ref="formData"
                  :model="formData"
                  :rules="formRules"
                  inline
                  :label-width="180"
                  label-position="right"
                  class="form-list"
            >
                <Row :gutter="16">
                    <Col span="24">
                        <FormItem label="企业名称：" prop="corpName">
                            <Input
                                    v-model="formData.corpName"
                                    placeholder="请输入"
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="企业统一社会信用代码：" prop="corpCode">
                            <Input
                                    v-model="formData.corpCode"
                                    placeholder="请输入"
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="企业类型：" prop="corpType">
                            <Select
                                    v-model="formData.corpType"
                                    filterable
                                    clearable
                                    label-in-value
                            >
                                <Option
                                        v-for="item in copeRegisterTypeArr"
                                        :value="item.code"
                                        :key="item.code"
                                >{{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="企业注册所在地：" prop="areaCodes">
                            <Cascader
                                    v-model="formData.areaCodes"
                                    :data="areaList"
                                    placeholder="请选择"
                            ></Cascader>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button @click="modalq = false">取消</Button>
                <Button @click="handleSubmit" :loading="qloading" type="primary">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState,mapGetters,mapActions} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    import { corpEditDetail, corpEditSave, getNationwide } from '@/api/platform'
    export default {
        mixins: [tableMixin],
        data(){
            const validateCode = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入企业统一社会信用代码'));
                } else {
                    if (value.length !== 9 && value.length !== 18) {
                        callback(new Error('请输入9位或者18位'));
                    }else {
                        callback();
                    }
                }
            };
            return {
                eLoading: false,
                formInline:{
                    //企业名称：
                    corpName:'',
                    //企业类型:
                    corpType:'',
                    corpAreaCode:"",
                    areaCode: localStorage.getItem('tenantAreaCode'),
                },
                selectData:[],
                corpAreaCode:[],
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '企业名称',
                        key: 'corpName',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '注册所在地',
                        key: 'areaName'
                    },
                    {
                        title: '企业类型',
                        key: 'corpType',
                        tooltip: true
                    },
                    {
                        title: '法人',
                        key: 'legalMan'
                    },
                    {
                        title: '成立日期',
                        key: 'registerDate',
                        tooltip: true
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                    }
                ],
                tableData:[],
                exportData:{},
                // 企业信息编辑 <
                modalq: false,
                qloading: false,
                areaList: [],
                formData: {
                    corpName: '',
                    corpCode: '',
                    corpType: '',
                    areaCodes: [],
                },
                formRules: {
                    corpName: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
                    corpCode: [
                        { required: true, message: '企业统一社会信用代码不能为空', trigger: 'blur' },
                        { validator: validateCode, trigger: 'blur' }
                    ],
                    corpType: [{ required: true, message: '企业类型不能为空', trigger: 'change' }],
                },
                // >
            };
        },
        computed:{
            ...mapState(['area', 'dict',"countiesAll"]),
            ...mapGetters(['corpType']),
            copeRegisterTypeArr() {
                return this.dict && this.dict.copeRegisterType || []
            },
        },
        created(){
            this.$route.query.areaCode && (this.formInline.areaCode = this.$route.query.areaCode)
        },
        mounted(){
            this.GetCountiesAll()
        },
        watch: {
        },
        methods: {
            ...mapActions(["GetAreas","GetCountiesAll"]),
            // 企业编辑 <
            // 获取全国行政区
            getNationwide() {
                if(this.areaList && this.areaList.length) {
                    return
                }
                getNationwide().then(res => {
                    const data = res.data.data || [];
                    this.areaList =  data[0] && data[0].children;

                })
            },
            handleEdit(item) {
                this.modalq = true;
                this.$refs.formData && this.$refs.formData.resetFields()
                this.formData = {
                    corpName: '',
                    corpCode: '',
                    corpType: '',
                    areaCodes: [],
                };
                this.corpEditDetail(item);
                this.getNationwide();
            },
            corpEditDetail(item) {
                corpEditDetail({
                    corpId: item.corpId
                }).then(res => {
                    if(res.data) {
                        const data = res.data.data || {};
                        data.areaCodes = data.areaCodeName && data.areaCodeName.split('-');
                        Object.assign(this.formData, res.data.data)
                    }
                })
            },
            // 提交
            handleSubmit() {
                this.$refs['formData'].validate((valid) => {
                    if (valid) {
                        const data = {
                            ...this.formData
                        };
                        data.areaCode = data.areaCodes[data.areaCodes.length-1];
                        this.qloading = true;
                        corpEditSave(data).then(res => {
                            this.qloading = false;
                            if(res.data.success) {
                                this.$Message.success('编辑成功!');
                                this.modalq = false;
                                this.getTableData()
                            }else {
                                this.$Message.error('失败!');
                            }
                        }).catch(() => {
                            this.qloading = false;
                        });
                    }
                })
            },
            // >
            //导出
            handleExport(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                this.formInline.corpType=this.formInline.corpType || '';
                Object.assign(param,this.formInline);
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/corp/export',
                    responseType:'arraybuffer',
                    data: param,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'企业信息.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name,uuid){
                this.$router.push({
                    name: name,
                    query: {
                        corpId:uuid
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                this.formInline.corpType=this.formInline.corpType || '';
                Object.assign(param,this.formInline);
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/corp/pageList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total;
                        this.tableData=response.data.data.records;
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
            //重置
            reset() {
                this.corpAreaCode = []
                this.formInline = {
                    corpName:'',
                    //企业类型:
                    corpType:'',
                    corpAreaCode:"",
                    areaCode: localStorage.getItem('tenantAreaCode'),
                }
                this.getTableData()
            },
    changeSelect(data, selectData) {
      console.log(data, selectData, "---------------");
      this.selectData = selectData;
      if (selectData.length) {
        this.formInline.corpAreaCode = selectData[selectData.length - 1].value;
      }else{
        this.formInline.corpAreaCode=""
        this.getTableData()
      }
    }
        }
    };
</script>
